/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import { Autocomplete, TextField } from "@mui/material";
// import Checkbox from "@mui/material/Checkbox";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Icons
import CheckIcon from "@mui/icons-material/Check";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-up-cover.jpeg";
import logo from "assets/images/logo-ct.png";

// Styles
import { useEffect, useState } from "react";
import {
  getCaptcha,
  resendVerificationEmail,
  studentgoogleLogin,
  studentregister,
} from "services/auth-service";
import { listCountry } from "tutor/services/country-service";
import useAlert from "hooks/use-alert";
import useLoading from "hooks/use-loading";

// import { BASE_URL } from "utils/urls";
import BasicModal from "components/MuiModal";
import { GoogleLogin } from "react-google-login";
import Grid from "@mui/material/Grid";
import { useDispatch } from "react-redux";

import classes from "./Signup.module.css";

import { loginHandler } from "../../../../store/login-slice";

function Cover() {
  const { setShowLoader } = useLoading();
  const [name, setName] = useState("");
  const [nameHasError, setNameHasError] = useState(false);
  const [nameErrorMessage, setNameErrorMessage] = useState("");

  const { createAlert } = useAlert();
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [emailHasError, setEmailHasError] = useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = useState("");

  const [phone, setPhone] = useState("");
  const [phoneHasError, setPhoneHasError] = useState(false);
  const [phoneErrorMessage, setPhoneErrorMessage] = useState("");

  const [emailRemember, setEmailRemember] = useState(false);
  const [isEmailSentAgain, setIsEmailSentAgain] = useState(false);

  const [password, setPassword] = useState("");
  const [passwordHasError, setPasswordHasError] = useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = useState("");

  const [captcha, setCaptcha] = useState("");
  const [captchaHasError, setCaptchaHasError] = useState(false);
  const [captchaHasErrorMessage, setCaptchaHasErrorMessage] = useState("");

  const [signUpError, setSignUpError] = useState(false);
  const [signUpErrorMessage, setSignUpErrorMessage] = useState("");

  const [showSignUpSuccess, setShowSignUpSuccess] = useState(false);

  const [captchaImage, setCaptchaImage] = useState("");
  const [captchaToken, setCaptchaToken] = useState("");

  const [countryValue, setCountryValue] = useState(null);
  const [countryData, setcountryData] = useState([]);
  const [countryCode, setcountryCode] = useState(null);
  const [countryError, setcountryError] = useState(false);
  const [countryErrorMessage, setcountryErrorMessage] = useState("");

  const [loginError, setLoginError] = useState(false);
  const [loginErrorMessage, setLoginErrorMessage] = useState("");

  function iscountryValid(newValue) {
    if (newValue && newValue.id && newValue.id > 0) {
      setcountryError(false);
      setcountryErrorMessage("");
      setcountryCode(newValue.phone_code);
      return true;
    }
    setcountryCode(null);
    setcountryError(true);
    setcountryErrorMessage("Please select a country");
    return false;
  }

  function isValidName(value) {
    if (value.length >= 2) {
      setNameHasError(false);
      setNameErrorMessage("");
      return true;
    }
    setNameHasError(true);
    setNameErrorMessage("Please enter  name");
    return false;
  }

  function isValidPhone(value) {
    if (value.length > 3) {
      setPhoneHasError(false);
      setPhoneErrorMessage("");
      return true;
    }
    setPhoneHasError(true);
    setPhoneErrorMessage("Please enter Number");
    return false;
  }

  function isValidEmail(value) {
    if (value.length > 3) {
      setEmailHasError(false);
      setEmailErrorMessage("");
      return true;
    }
    setEmailHasError(true);
    setEmailErrorMessage("Please enter valid email");
    return false;
  }

  function isValidPassword(value) {
    if (value.length >= 6) {
      setPasswordHasError(false);
      setPasswordErrorMessage("");
      return true;
    }
    setPasswordHasError(true);
    setPasswordErrorMessage("Password length should be atleast 6");
    return false;
  }

  function isValidCaptcha(value) {
    if (value.length > 0) {
      setCaptchaHasError(false);
      setCaptchaHasErrorMessage("");
      return true;
    }
    setCaptchaHasError(true);
    setCaptchaHasErrorMessage("Enter a valid captcha");
    return false;
  }

  const getCountryList = async () => {
    try {
      setShowLoader(true);
      const res = await listCountry();
      if (res.status) {
        setcountryData(res.data);
      } else {
        createAlert(res.message, "error");
      }
    } catch (error) {
      createAlert("Something went wrong. Please try again later", "error");
      // console.log(error);
    }
    setShowLoader(false);
  };

  useEffect(() => {
    getCountryList();
  }, []);

  // const navigate = useNavigate();

  useEffect(() => {
    // eslint-disable-next-line no-undef
    document.title = "Sign Up";
  }, []);

  useEffect(() => {
    async function fetchCaptcha() {
      setShowLoader(true);
      try {
        const res = await getCaptcha();
        setCaptchaImage(res.captcha);
        setCaptchaToken(res.captcha_token);
      } catch (err) {
        setSignUpError(true);
        setSignUpErrorMessage("Something went wrong. Please try again later.");
        // console.log(err);
      }
      setShowLoader(false);
    }

    fetchCaptcha();
  }, []);

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    let isValid = true;
    if (!iscountryValid(countryValue)) isValid = false;
    if (!isValidName(name)) isValid = false;
    if (!isValidPhone(phone)) isValid = false;
    if (!isValidEmail(email)) isValid = false;
    if (!isValidPassword(password)) isValid = false;
    if (!isValidCaptcha(captcha)) isValid = false;
    if (!isValid) {
      return;
    }
    if (isValid) {
      try {
        setShowLoader(true);
        const res = await studentregister(
          name,
          email,
          password,
          captcha,
          captchaToken,
          phone,
          countryCode
        );
        if (res.status) {
          setEmailRemember(email);
          setShowSignUpSuccess(true);
          // navigate("/authentication/sign-in");
        } else {
          setSignUpError(true);
          setSignUpErrorMessage(res.message);
        }
        setShowLoader(false);
      } catch (e1) {
        setShowLoader(false);
      }
    }
  };

  const emailChangeHandler = (e) => {
    setEmail(e.target.value);
    const checvalid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.target.value);
    setEmailHasError(!checvalid);
    if (!checvalid) {
      setEmailErrorMessage("Please Enter Valid Email");
    } else {
      setEmailErrorMessage("");
    }
  };

  const phoneChangeHandler = (e) => {
    setPhone(e.target.value);
    isValidPhone(e.target.value);
  };

  const passwordChangeHandler = (e) => {
    setPassword(e.target.value);
    isValidPassword(e.target.value);
  };

  const captchaChangeHandler = (e) => {
    setCaptcha(e.target.value);
    isValidCaptcha(e.target.value);
  };

  const nameChangeHandler = (e) => {
    setName(e.target.value);
    // setIsNameValid(e.target.value.length >= 2);
    isValidName(e.target.value);
  };

  const navigateToHome = () => {
    document.location.href = "https://tutorshell.com";
  };

  const onLoginWithGoogleSuccess = async (response) => {
    try {
      setShowLoader(true);
      const token = response.credential;

      const res = await studentgoogleLogin(token);
      if (res.status) {
        dispatch(
          loginHandler({
            token: res.token,
            userRole: res.data.user_role,
            name: res.data.name,
            phone: res.data.phone,
            email: res.data.email,
            isPlanExpired: String(res.plan_expired),
            apiKey: res.data.api_key,
            apiSecret: res.data.api_secret,
            tutorVerify: res.data.tutor_verify,
            isStudentPaid: String(res.is_student_paid),
            paymentGateway: res.payment_gateway,
            stripeVerified: res.stripe_verified,
            razorpayVerified: res.razorpay_verified,
            isManualStudent: res.data.userflag === 1 ? "true" : "false",
            isTutorMapped: String(res.isTutorMapped),
          })
        );
      } else {
        setLoginError(true);
        setLoginErrorMessage(res.message);
      }
    } catch (err) {
      // console.error(err.message);
      setLoginError(true);
      setLoginErrorMessage(err.message);
    }
    setShowLoader(false);
  };

  // const onLoginWithGoogleFailure = (response) => {
  const onLoginWithGoogleFailure = () => {
    createAlert("Login with google failed!", "error");
  };

  // const onSignoutSuccess = () => {};

  useEffect(() => {
    /* global google */
    if (
      typeof google !== "undefined" &&
      typeof google.accounts !== "undefined" &&
      typeof google.accounts.id !== "undefined"
    ) {
      google.accounts.id.initialize({
        client_id: "334348115714-0q75fgdldm2ioc33j7akg4lvf8hr0hva.apps.googleusercontent.com",
        callback: onLoginWithGoogleSuccess,
      });

      google.accounts.id.renderButton(document.getElementById("signinStudent"), {
        theme: "outline",
        size: "large",
        text: "signup_with",
        context: "signup",
      });

      google.accounts.id.prompt();
    }
  }, []);

  const resendEmailHandler = () => {
    const resend = async () => {
      try {
        setShowLoader(true);
        const res = await resendVerificationEmail(emailRemember);
        if (res.status) {
          setIsEmailSentAgain(true);
        } else {
          setSignUpError(true);
          setSignUpErrorMessage(res.message);
          showSignUpSuccess(false);
        }
      } catch (error) {
        setSignUpError(true);
        setSignUpErrorMessage("Something went wrong. Please try again later.");
        // console.log(error);
      }
      setShowLoader(false);
    };
    resend();
  };

  useEffect(() => {
    if (isEmailSentAgain) {
      setTimeout(() => {
        setIsEmailSentAgain(false);
      }, 5000);
    }
  }, [isEmailSentAgain]);

  return (
    <BasicLayout image={bgImage}>
      <div
        style={{
          position: "absolute",
          top: "10px",
          left: "10px",
          cursor: "pointer",
        }}
        onClick={navigateToHome}
      >
        <img src={logo} width="100" alt="logo" />
      </div>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Student Sign Up
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Enter your email and password to register
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          {/* error message */}
          {signUpError && (
            <MDTypography variant="h6" color="error" align="center" style={{ fontSize: "13px" }}>
              {signUpErrorMessage}
            </MDTypography>
          )}
          <BasicModal open={showSignUpSuccess} onClose={() => setShowSignUpSuccess(false)}>
            <MDTypography variant="h6" color="success" align="center" style={{ fontSize: "13px" }}>
              Sign up successful. Please check your email to verify your account.
            </MDTypography>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <MDButton
                onClick={() => setShowSignUpSuccess(false)}
                color="success"
                variant="contained"
                startIcon={<CheckIcon />}
              >
                Okay
              </MDButton>
            </div>
            <div>
              <MDTypography align="center" style={{ fontSize: "13px" }}>
                If you don&lsquo;t receive an email, please check your spam folder or{" "}
                <span
                  style={{ fontSize: "13px", cursor: "pointer", color: "#1A73E8" }}
                  onClick={resendEmailHandler}
                >
                  <u>click here to resend the email.</u>
                </span>
              </MDTypography>
              {isEmailSentAgain && (
                <MDTypography align="center" style={{ fontSize: "13px" }} color="success">
                  Email sent. Please check your email.
                </MDTypography>
              )}
            </div>
          </BasicModal>
          <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
            <div id="signinStudent">{}</div>
            {/* <GoogleLogin
              style={{ borderRadius: "10px !important", overflow: "hidden" }}
              clientId={clientId}
              buttonText="Sign Up with Google As Student"
              onSuccess={onLoginWithGoogleSuccess}
              onFailure={onLoginWithGoogleFailure}
              cookiePolicy="single_host_origin"
            /> */}
            {/* <GoogleLogout
                clientId={clientId}
                buttonText="Sign Out"
                onLogoutSuccess={onSignoutSuccess}
              >
              </GoogleLogout> */}
          </Grid>
          <MDBox>
            {/* error message */}
            {loginError && (
              <MDTypography variant="h6" color="error" align="center" style={{ fontSize: "13px" }}>
                {loginErrorMessage}
              </MDTypography>
            )}
          </MDBox>
          <form onSubmit={onSubmitHandler}>
            <MDBox mb={2}>
              <MDInput
                className={`${nameHasError ? classes.error : ""}`}
                error={nameHasError}
                helperText={nameErrorMessage}
                onChange={nameChangeHandler}
                value={name}
                type="text"
                label="Name"
                variant="standard"
                fullWidth
              />
            </MDBox>
            <MDBox mb={2}>
              <Autocomplete
                value={countryValue === undefined ? null : countryValue}
                onChange={(event, newValue) => {
                  setCountryValue(newValue);
                  iscountryValid(newValue);
                }}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                options={countryData}
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return `${option.name} (+${option.phone_code})`;
                }}
                renderOption={(props, option) => (
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  <li {...props} key={option.id}>{`${option.name} (+${option.phone_code})`}</li>
                )}
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    error={countryError}
                    helperText={countryErrorMessage}
                    label="Select Country"
                    fullWidth
                  />
                )}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                onChange={phoneChangeHandler}
                value={phone}
                type="number"
                label="Phone Number"
                variant="standard"
                fullWidth
                className={`${phoneHasError ? classes.error : ""}`}
                error={phoneHasError}
                helperText={phoneErrorMessage}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                onChange={emailChangeHandler}
                value={email}
                type="email"
                label="Email"
                variant="standard"
                fullWidth
                className={emailHasError ? classes.error : ""}
                error={emailHasError}
                helperText={emailErrorMessage}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                error={passwordHasError}
                className={`${passwordHasError ? classes.error : ""}`}
                helperText={passwordErrorMessage}
                onChange={passwordChangeHandler}
                value={password}
                type="password"
                label="Password"
                variant="standard"
                fullWidth
              />
            </MDBox>
            <MDBox mb={2}>
              <span
                style={{
                  padding: "0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                captcha: <img src={`data:image/png;base64,${captchaImage}`} alt="captcha" />
              </span>
              <MDInput
                error={captchaHasError}
                className={`${captchaHasError ? classes.error : ""}`}
                helperText={captchaHasErrorMessage}
                onChange={captchaChangeHandler}
                value={captcha}
                type="text"
                label="Captcha"
                variant="standard"
                fullWidth
              />
            </MDBox>
            {/* <MDBox display="flex" alignItems="center" ml={-1}>
              <Checkbox />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;I agree the&nbsp;
              </MDTypography>
              <MDTypography
                component="a"
                href="#"
                variant="button"
                fontWeight="bold"
                color="info"
                textGradient
              >
                Terms and Conditions
              </MDTypography>
            </MDBox> */}
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth type="submit">
                sign up
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Already have an account?{" "}
                <MDTypography
                  component={Link}
                  to="/authentication/sign-in"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Sign In
                </MDTypography>
              </MDTypography>
            </MDBox>
          </form>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Cover;
